/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowAUpIcon16Light = forwardRef('ArrowAUpIcon16Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M2.854 7.27a.5.5 0 1 1-.708-.708l4.006-4.006a1.906 1.906 0 0 1 2.696 0l4.006 4.006a.5.5 0 0 1-.708.707L8.141 3.263A.91.91 0 0 0 8 3.148V13.5a.5.5 0 0 1-1 0V3.148a.91.91 0 0 0-.14.115L2.853 7.27Z" })));
});
